<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" right color="#FEBD08">
      <v-layout wrap>
        <v-flex xs11>
          {{ msg }}
        </v-flex>
        <v-flex xs1>
          <v-icon @click="snackbar = !snackbar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!-- <v-layout wrap>
      <v-flex xs12>
        <h1>cake</h1>
      </v-flex>
    </v-layout> -->

    <v-layout wrap>
      <v-flex xs12 text-left>
        <span style="font-size: 20px; color: grey">Choose quantity type</span>
        <v-radio-group v-model="quantityType" mandatory>
          <v-layout wrap>
            <v-flex xs4>
              <v-radio color="yellow" label="Kilo grams" value="kg"></v-radio
            ></v-flex>
            <v-flex xs4>
              <v-radio color="yellow" label="Grams" value="gm"> </v-radio>
            </v-flex>
          </v-layout>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <!-- <v-flex xs12 align-self-baseline pt-6>
        <v-switch
          color="yellow"
          v-model="portionProduct"
          label="Does this product have different portions...?"
        ></v-switch>
      </v-flex> -->
      <v-flex xs12>
        <v-layout wrap>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              disabled
              label="Product Name *"
              v-model="commonData.name"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              :disabled="full == false ? true : false"
              label="Price (Rs) *"
              v-model="price"
              @input="checkDiscount"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              @input="checkDiscount"
              :rules="[rules.discount]"
              prepend-icon="mdi-percent"
              :disabled="price > 0 ? false : true"
              v-model="discount"
              label="Discount Percentage"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              ref="offerPrice"
              :rules="[rules.offerPrice]"
              :disabled="price > 0 ? false : true"
              prepend-icon="mdi-currency-inr"
              v-model="offerPrice"
              @input="checkOfferPrice"
              label="Offer Price"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              :disabled="full == false ? true : false"
              label="Serve for"
              v-model="serveFor"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <span text-left style="font-size: 12px; color: grey"
              >Choose Commission Type</span
            >
            <v-radio-group v-model="commissionType" mandatory>
              <v-layout wrap>
                <v-flex xs6>
                  <v-radio
                    color="yellow"
                    label="Percentage"
                    value="percentage"
                  ></v-radio
                ></v-flex>
                <v-flex xs6>
                  <v-radio
                    color="yellow"
                    label="Amount"
                    value="amount"
                  ></v-radio
                ></v-flex>
              </v-layout>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              :disabled="commissionType == 'percentage' ? false : true"
              @input="checkDiscount"
              ref="commissionPercentage"
              :rules="[rules.required]"
              prepend-icon="mdi-percent"
              v-model="commissionPercentage"
              label="Commission Percentage"
            >
            </v-text-field>
          </v-flex>
          <!-- commission price-->
          <v-flex xs12 lg3 px-2>
            <v-text-field
              :disabled="commissionType == 'amount' ? false : true"
              @input="checkOfferPrice"
              :rules="[rules.required]"
              prepend-icon="mdi-currency-inr"
              v-model="commission"
              label="Commission Amount"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              label="Weight"
              v-model="ProductWeight"
              :append-outer-icon="quantityType"
            >
            </v-text-field>
          </v-flex>
          <!-- <v-flex xs12 text-left pl-2 pb-4>
            <v-btn @click="cuztom = true"> add customization <v-icon>mdi-plus</v-icon> </v-btn>
          </v-flex> -->
          <v-flex xs12 lg4 pa-1 v-for="(item, i) in customFields" :key="i">

             <!-- mainProductCustom: {
        price: 0,
        discount: 0,
        offerPrice: 0,
        offerPercentage: 0,
        quantity: 0,
        preparationTime: 0,
        name: null,
      }, -->
           
        
     <v-card outlined>
       <v-layout wrap justify-start pa-4 >
         <v-flex xs8 text-left>
          <span>Price</span>
         </v-flex>
         <v-flex xs4 text-left>
             {{item.name}}
         </v-flex>
         <v-flex xs8 text-left>
          <span>discount</span>
         </v-flex>
         <v-flex xs4 text-left>
             {{item.discount}}
         </v-flex>
         <v-flex xs8 text-left>
          <span>Price</span>
         </v-flex>
         <v-flex xs4 text-left>
             {{item.price}}
         </v-flex>
         <v-flex xs8 text-left>
          <span>offerPrice</span>
         </v-flex>
         <v-flex xs4 text-left>
             {{item.offerPrice}}
         </v-flex>
          <v-flex xs8 text-left>
          <span>offerPercentage</span>
         </v-flex>
         <v-flex xs4 text-left>
             {{item.offerPercentage}}
         </v-flex>
         <v-flex xs12>
          <v-btn color="primary" text>
            Delete
          </v-btn>
         </v-flex>
       </v-layout>
     </v-card>



          </v-flex>

          <v-flex xs12 pt-4 style="border-bottom: 3px solid black"> </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12>
        <v-layout wrap v-for="(item, i) in variant" :key="i" py-4>
          <!-- <v-flex xs12 lg3 px-2>
            <v-text-field
              :disabled="full == false ? true : false"
              label="Product Name"
              v-model="item.productName"
            >
            </v-text-field>
          </v-flex> -->
          <v-flex xs12 lg3 px-2>
            <v-text-field
              :disabled="full == false ? true : false"
              label="Price (Rs)"
              v-model="item.price"
              @input="checkDiscountvariant(i)"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              @input="checkDiscountvariant(i)"
              :rules="[rules.discount]"
              prepend-icon="mdi-percent"
              :disabled="item.price > 0 ? false : true"
              v-model="item.discount"
              label="Discount Percentage"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              ref="offerPrice"
              :rules="[rules.offerPrice]"
              :disabled="item.price > 0 ? false : true"
              prepend-icon="mdi-currency-inr"
              v-model="item.offerPrice"
              @input="checkOfferPricevaiant(i)"
              label="Offer Price"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              :disabled="full == false ? true : false"
              label="Serve for"
              v-model="item.serveFor"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <span text-left style="font-size: 12px; color: grey"
              >Choose Commission Type</span
            >
            <v-radio-group v-model="item.commissionType" mandatory>
              <v-layout wrap>
                <v-flex xs6>
                  <v-radio
                    color="yellow"
                    label="Percentage"
                    value="percentage"
                  ></v-radio
                ></v-flex>
                <v-flex xs6>
                  <v-radio
                    color="yellow"
                    label="Amount"
                    value="amount"
                  ></v-radio
                ></v-flex>
              </v-layout>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              :disabled="item.commissionType == 'percentage' ? false : true"
              @input="checkDiscountvariant(i)"
              ref="commissionPercentage"
              :rules="[rules.required]"
              prepend-icon="mdi-percent"
              v-model="item.commissionPercentage"
              label="Commission Percentage"
            >
            </v-text-field>
          </v-flex>
          <!-- commission price-->
          <v-flex xs12 lg3 px-2>
            <v-text-field
              :disabled="item.commissionType == 'amount' ? false : true"
              @input="checkOfferPricevariant(i)"
              :rules="[rules.required]"
              prepend-icon="mdi-currency-inr"
              v-model="item.commission"
              label="Commission Amount"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-2>
            <v-text-field
              label="Weight"
              v-model="item.ProductWeight"
              :append-outer-icon="quantityType"
            >
            </v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              prepend-icon="mdi-book"
              v-model="item.description"
              label="description"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 text-right>
            <v-btn text dark color="primary" @click="variant.splice(i, 1)">
              delete
            </v-btn>
          </v-flex>
          <v-flex xs12 pt-4 style="border-bottom: 3px solid black"> </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 text-center pt-3>
        <v-btn width="200px" color="error" @click="addingNextVariant">
          Add variant <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout wrap pt-3>
      <v-flex xs12 text-left py-4>
        <b>Images</b>
      </v-flex>
      <v-flex xs12 md4>
        <ImageComp
          @stepper="winStepper"
           :singleImage="pics[0]"
          typr
          :height="1"
          :width="1"
          :heading="'Upload Main Image'"
          :componentType="'itemImage'"
        />
      </v-flex>
      <v-flex xs12 md4 px-1>
        <ImageComp
         :singleImage="pics[1]"
          @stepper="winStepper"
          typr
          :height="1"
          :width="1"
          :heading="'Upload Product Image'"
          :componentType="'restaurantImage'"
        />
      </v-flex>
      <v-flex xs12 md4>
        <ImageComp
         :singleImage="pics[2]"
          @stepper="winStepper"
          typr
          :height="1"
          :width="1"
          :heading="'Upload Packing Image'"
          :componentType="'packingImage'"
        />
      </v-flex>
    </v-layout>

    <v-layout wrap pt-4>
      <v-flex xs12>
        <v-switch
          color="yellow"
          v-model="addOnAvailable"
          label="Add On available...?"
        ></v-switch>
      </v-flex>
    </v-layout>
     <v-layout wrap v-if="addOnAvailable == true">
      <v-flex xs12 text-left py-3>
        <v-btn
          style="border-radius: 30px"
          dark
          dense
          color="primary "
          @click="AddOnDialog = true"
        >
          add On <v-icon x-small>mdi-plus</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 md4 lg3 v-for="(item, i) in addOnFinal" :key="i" pa-1>
        <v-card>
          <v-layout wrap pa-3 text-left>
            <v-flex xs6> Name: </v-flex>
            <v-flex xs6>
              {{ item.addOnName }}
            </v-flex>
            <v-flex xs6> Price: </v-flex>
            <v-flex xs6>
              {{ item.addOnPrice }}
            </v-flex>
            <template >
            <v-flex xs6 > Quantity: </v-flex>
            <v-flex xs6>
              {{ item.addOnqQantity }}
            </v-flex>
            </template>
            <v-flex xs12 text-right>
              <v-btn color="error" text dense @click="addOnFinal.splice(i, 1)">
                delete
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap pb-16>
      <v-flex>
        <v-btn color="black" dark dense block @click="addFoodProduct">
          Save
        </v-btn>
      </v-flex>
    </v-layout>
     <v-dialog width="600px" v-model="AddOnDialog">
      <v-card>
        <v-layout wrap pa-12>
          <v-flex xs12>
            <v-text-field v-model="addOn.addOnName" label="Name"> </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="addOn.addOnPrice" label="Price "> </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="addOn.addOnqQantity" label="Quantity">
            </v-text-field>
          </v-flex>
          <v-flex xs12 text-right>
            <v-btn color="error" text @click="addOnDialog = false">
              Cancel
            </v-btn>
            <v-btn color="primary" text @click="toAddOn()"> save </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog width="600px" v-model="cuztom">
      <v-card>
        <v-layout wrap pa-12>
          <v-flex xs12>
            <v-text-field v-model="mainProductCustom.name" label="Flavour/Name">
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="mainProductCustom.quantity"
              label="Customizible Quantity "
              :append-outer-icon="quantityType"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="mainProductCustom.price"
              label="Customizible Prize "
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="mainProductCustom.preparationTime"
              label=" PreparationTime (minutes)"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :disabled="mainProductCustom.price == 0 ? true : false"
              @input="checkDiscountCustom()"
              v-model="mainProductCustom.discount"
              label="OfferPercentage"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              @input="checkOfferPriceCustom()"
              :disabled="mainProductCustom.price == 0 ? true : false"
              v-model="mainProductCustom.offerPrice"
              label=" OfferPrice"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 text-right>
            <v-btn color="error" text> Cancel </v-btn>
            <v-btn color="primary" text @click="toMainProductCuz()">
              save
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
 <script>
import ImageComp from "@/components/Common/singleImage";
import axios from "axios";
export default {
  components: {
    ImageComp,
  },
  props: [
    "quantityType",
    "commonData",
   "portion",
    "pics",
    "variants",
    "ProductWeight",
    "basevariant",
    "price",
    "discount",
    "offerPrice",
    "serveFor",
    "commissionType",
    "commissionPercentage",
    "commission",
    "addOnIds"],
  data() {
    return {
      sample: {},
      AlredyExistVariant:[],
      AddOnDialog: false,
      addOn: {
        index: 0,
        addOnName: null,
        addOnPrice: 0,
        addOnqQantity: 0,
      },
       addOnFinal: [],

      customFields: [],
      mainProductCustom: {
        price: 0,
        discount: 0,
        offerPrice: 0,
        offerPercentage: 0,
        quantity: 0,
        preparationTime: 0,
        name: null,
      },
      totalDataLength: 0,
      cuztom: false,
      // quantityType: null,
      variant: [],
      FINAL: [],
      variantFields: {
        productName: null,
        serveFor: null,
        addOnAvailable: false,
        appLoading: false,
        commission: 0,
        itemImage: "",
        packingImage: "",
        restaurantImage: "",
        commissionType: null,
        portionProduct: false,
        full: true,
        half: false,
        qtr: false,
        price: 0,
        discount: 0,
        offerPrice: 0,
        commissionPercentage: 0,
        description: "",
        ProductWeight: null,
      },
      variantFields2: {
        productName: null,
        serveFor: null,
        addOnAvailable: false,
        appLoading: false,
        commission: 0,
        itemImage: "",
        packingImage: "",
        restaurantImage: "",
        commissionType: null,
        portionProduct: false,
        full: true,
        half: false,
        qtr: false,
        price: 0,
        discount: 0,
        offerPrice: 0,
        commissionPercentage: 0,
        description: "",
        ProductWeight: null,
      },
      // ProductWeight: null,
      productName: null,
      // serveFor: null,
      addOnAvailable: false,
      appLoading: false,
      // commission: 0,
      itemImage: "",
      packingImage: "",
      restaurantImage: "",
      // commissionType: null,
      portionProduct: true,
      full: true,
      half: false,
      qtr: false,
      // price: 0,
      // discount: 0,
      // offerPrice: 0,
      snackbar: false,
      msg: "",
      // commissionPercentage: 0,
      formData: new FormData(),
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        discount: (value) =>
          (value < 100 && value >= 0) || "Discount must be between 0-100",
        offerPrice: (value) => value >= 0 || "Offer price should be valid ",
      },
    };
  },
  
  mounted()
  {
 this.AlredyExistVariant = this.variants;
    console.log("this.AlredyExistVariant==", this.AlredyExistVariant);
    for (let i = 0; i < this.AlredyExistVariant.length; i++) {
      this.variantFields2.ProductWeight = this.AlredyExistVariant[i].weight;
      // this.variantFields2.productName = this.AlredyExistVariant[i].weight;
// 
      // console.log("portion", this.AlredyExistVariant[i].portion);
      // console.log("portion2", this.variantFields2.portion);
      this.variantFields2.price = this.AlredyExistVariant[i].varientPrice;
      this.variantFields2.discount =
        this.AlredyExistVariant[i].varientOfferPercentage;
      this.variantFields2.offerPrice =
        this.AlredyExistVariant[i].varientOfferPrice;
      this.variantFields2.serveFor = this.AlredyExistVariant[i].varientServeFor;
      this.variantFields2.description =
        this.AlredyExistVariant[i].varientDescription;

      this.variantFields2.varientId = this.AlredyExistVariant[i]._id;

      // commission
      this.variantFields2.commission = this.AlredyExistVariant[i].commission;
      this.variantFields2.commissionPercentage =
        this.AlredyExistVariant[i].commissionPercentage;

      // this.variantFields2.commissionType = this.AlredyExistVariant[i].varientServeFor;
      console.log("this.variantFields2==", this.variantFields2);
      this.variant.push(JSON.parse(JSON.stringify(this.variantFields2)));
    }
    if (this.addOnIds.length > 0) {
      this.addOnAvailable = true;
    }
    for (let i = 0; i < this.addOnIds.length; i++) {
      this.sample.addOnName = this.addOnIds[i].addOnName;
      this.sample.addOnPrice = this.addOnIds[i].addOnPrice;
      this.sample.addOnqQantity = this.addOnIds[i].addOnqQantity;
      this.sample.addonId = this.addOnIds[i]._id;


      // _id: "6274ac9e44699b2da4fa7202"
      this.addOnFinal.push(JSON.parse(JSON.stringify(this.sample)));
    }

    
  },


  methods: {
   
    toAddOn() {
      let c = this.addOnFinal.length;
      this.addOn.index = c;
      this.addOnFinal.push(JSON.parse(JSON.stringify(this.addOn)));
      console.log("im  working", this.addOnFinal);
      this.AddOnDialog = false;
    },


    toMainProductCuz() {
      this.customFields.push(
        JSON.parse(JSON.stringify(this.mainProductCustom)));

      // console.log("customFields", this.customFields);
    },
    checkOfferPriceCustom() {
      if (this.mainProductCustom.offerPrice <= this.mainProductCustom.price) {
        this.mainProductCustom.discount = (
          100 -
          (this.mainProductCustom.offerPrice / this.mainProductCustom.price) *
            100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid offer price";
        this.snackbar = true;
        this.mainProductCustom.offerPrice = this.mainProductCustom.price;
        this.mainProductCustom.discount = 0;
      }
    },
    checkDiscountCustom() {
      if (
        this.mainProductCustom.discount >= 0 &&
        this.mainProductCustom.discount < 100
      ) {
        this.mainProductCustom.offerPrice = (
          this.mainProductCustom.price -
          (this.mainProductCustom.price * this.mainProductCustom.discount) / 100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid discount";
        this.mainProductCustom.snackbar = true;
        this.mainProductCustom.offerPrice = 0;
        this.mainProductCustom.discount = 0;
      }
    },

    winStepper(window_data) {
      if (window_data.type == "itemImage") {
        this.itemImage = window_data.selectedFiles;
      }
      if (window_data.type == "packingImage") {
        this.packingImage = window_data.selectedFiles;
      }
      if (window_data.type == "restaurantImage") {
        this.restaurantImage = window_data.selectedFiles;
      }
    },
    checkDiscount() {
      if (this.discount >= 0 && this.discount < 100) {
        this.offerPrice = (
          this.price -
          (this.price * this.discount) / 100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid discount";
        this.snackbar = true;
        this.offerPrice = 0;
        this.discount = 0;
      }
      if (this.commissionPercentage >= 0 && this.commissionPercentage < 100) {
        this.commission = (this.offerPrice * this.commissionPercentage) / 100;
      } else {
        this.msg = "Please Provide valid commission percentage";
        this.snackbar = true;
        // this.offerPrice = 0;
        // this.discount = 0;
      }
    },
    checkOfferPrice() {
      if (typeof this.offerPrice == "string") {
        this.offerPrice = parseInt(this.offerPrice);
      }
      if (this.offerPrice <= this.price) {
        this.discount = (100 - (this.offerPrice / this.price) * 100).toFixed(2);
      } else {
        this.msg = "Please Provide valid offer price";
        this.snackbar = true;
        this.offerPrice = this.price;
        this.discount = 0;
      }
      if (this.offerPrice >= this.commission) {
        this.commissionPercentage = (
          ((this.offerPrice - (this.offerPrice - this.commission)) /
            this.offerPrice) *
          100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid commission price";
        this.snackbar = true;
        this.offerPrice = this.price;
        this.commission = 0;
        this.commissionPercentage = 0;
        this.discount = 0;
      }
    },
    addFoodProduct() {
      this.formData.append("productId", this.$route.query.id);
      this.formData.append("isPreOrderOnly", this.commonData.preOrder);
      this.formData.append("userid", this.$route.query.seller);
      // this.formData.append("categoryId", this.commonData.categoryId._id);
      this.formData.append("categoryId", this.commonData.categoryId);

      this.formData.append("name", this.commonData.name);
      this.formData.append("description", this.commonData.description);
      this.formData.append("ingredients", this.commonData.mingredients);
      this.formData.append("servesFor", this.serveFor);
      // this.formData.append("allergens", this.commonData.allergens);
      this.formData.append( "allergens",(JSON.stringify(this.commonData.allergens)));

      this.formData.append(
        "suitableForDiabetic",
        this.commonData.suitableForDiabetic
      );
      this.formData.append("price", this.price);
      this.formData.append("discount", this.discount);
      this.formData.append("offerPrice", this.offerPrice);
      // commonData.productType
      this.formData.append("foodType", "cake");
      this.formData.append("productType", "food");

      this.formData.append("productName", this.productName);
      this.formData.append("type", this.commonData.productType);
      this.formData.append(
        "maxOrderQuantity",
        this.commonData.maxOrderQuantity
      );
      // this.formData.append("availableTimings",this.commonData.availableTimings);
      this.formData.append( "availableTimings",(JSON.stringify(this.commonData.availableTimings)));



      this.formData.append("preparationTime", this.commonData.preparationTime);
      this.formData.append("packingCharge", this.commonData.packingCharge);
      this.formData.append("listingOrder", this.commonData.listingOrder);
      this.formData.append("isVarientAvailable", this.portionProduct);
      this.formData.append("isAddOnAvailable", this.addOnAvailable);
      this.formData.append("commissionType", this.commissionType);
      this.formData.append("commissionPercentage", this.commissionPercentage);
      this.formData.append("commission", this.commission);
      this.formData.append("isAllTime", this.commonData.isAllTime);
      this.formData.append("photo", this.itemImage);
      // this.formData.append("photo", this.itemImage);
      this.formData.append("productPhoto", this.restaurantImage);
      this.formData.append("packedPhoto", this.packingImage);
      this.formData.append("weight", this.ProductWeight);
      this.formData.append("quantityUnit", this.quantityType);


      for (let i = 0; i < this.addOnFinal.length; i++) {
        this.addOnFinal[i].index = i;
        
      }
      this.formData.append("addOn",JSON.stringify(this.addOnFinal));

      if (this.variant.length > 0) {
        var final = [];
        var singleVariant = {};
        for (let i = 0; i < this.variant.length; i++) {
          singleVariant.index = i + 1;
          singleVariant.productType = "food";
          singleVariant.foodType = "cake";
          singleVariant.varientPrice = this.variant[i].price;
          singleVariant.productName = this.variant[i].productName;
          singleVariant.varientOfferPrice = this.variant[i].offerPrice;
          singleVariant.varientServeFor = this.variant[i].serveFor;
          singleVariant.isCustomized = false;
          singleVariant.varientOfferPercentage = this.variant[i].discount;
          singleVariant.varientDescription = this.variant[i].description;
          singleVariant.commissionType = this.variant[i].commissionType;
          singleVariant.commissionPercentage =
            this.variant[i].commissionPercentage;
          singleVariant.commission = this.variant[i].commission;
          singleVariant.productName = this.variant[i].productName;
          singleVariant.weight = this.variant[i].ProductWeight;
          singleVariant.quantityUnit = this.quantityType;
          singleVariant.isCustomized = false;
          if (this.variant[i].varientId) {
            singleVariant.varientId = this.variant[i].varientId;
          }

          // final.push(JSON.parse(JSON.stringify(singleVariant)));
          final.push(singleVariant);
          singleVariant = {};
        }
        this.formData.append("varient", JSON.stringify(final));
        // console.log("singleVariant", singleVariant);
        // console.log("final", final);
        // console.log("formData", this.formData);
      }

      axios({
        method: "post",
        url: "/edit/product/varients/admin",
        // url: "/admin/seller/product/addvarients",
        data: this.formData,
        headers: {
          token: localStorage.getItem("token"),
        },
      }).then((response) => {
        if (response.data.status) {
          this.snackbar = true;
          this.msg = response.data.msg;
        } else {
          this.snackbar = true;
          this.msg = response.data.msg;
          this.formData = new FormData();
        }
      });
    },
    addingNextVariant() {
      this.variant.push(JSON.parse(JSON.stringify(this.variantFields)));
    },
    checkDiscountvariant(index) {
      if (
        this.variant[index].discount >= 0 &&
        this.variant[index].discount < 100
      ) {
        this.variant[index].offerPrice = (
          this.variant[index].price -
          (this.variant[index].price * this.variant[index].discount) / 100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid discount";
        this.snackbar = true;
        this.variant[index].offerPrice = 0;
        this.variant[index].discount = 0;
      }
      if (
        this.variant[index].commissionPercentage >= 0 &&
        this.variant[index].commissionPercentage < 100
      ) {
        this.variant[index].commission =
          (this.variant[index].offerPrice *
            this.variant[index].commissionPercentage) /
          100;
      } else {
        this.msg = "Please Provide valid commission percentage";
        this.snackbar = true;
      }
    },
    checkOfferPricevariant(index) {


      if (typeof this.variant[index].offerPrice == "string") {
        this.variant[index].offerPrice = parseInt(
          this.variant[index].offerPrice
        );
      }
      if (this.variant[index].offerPrice <= this.variant[index].price) {
        this.variant[index].discount = (
          100 -
          (this.variant[index].offerPrice / this.variant[index].price) * 100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid offer price";
        this.snackbar = true;
        this.variant[index].offerPrice = this.variant[index].price;
        this.variant[index].discount = 0;
      }
      if (this.variant[index].offerPrice > this.variant[index].commission) {
        this.variant[index].commissionPercentage = (
          ((this.variant[index].offerPrice -
            (this.variant[index].offerPrice - this.variant[index].commission)) /
            this.variant[index].offerPrice) *
          100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid commission price";
        this.snackbar = true;
        this.variant[index].offerPrice = this.variant[index].price;
        this.variant[index].commission = 0;
        this.variant[index].commissionPercentage = 0;
        this.variant[index].discount = 0;
      }
    },
  },
};
</script>